import { CAPABILITIES, STATS, IMAGES } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Capabilities = () => {
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative bg-[#F5F1EA] py-24 md:py-40 border-t border-[#C9C3B4]"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left sticky-ish header + image */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0055FF]">
                / Capabilities
              </span>
              <h2 className="font-display font-800 tracking-tighter text-3xl md:text-5xl mt-6 leading-[0.95]">
                Built like a blueprint. Run like a factory.
              </h2>
              <p className="text-[#55524B] mt-6 leading-relaxed max-w-md">
                A vertically-focused injection moulding operation running TOYO
                machinery — engineered for tolerance, speed, and repeatability.
              </p>
            </Reveal>
            <Reveal delay={0.1} className="mt-10 relative overflow-hidden border border-[#C9C3B4] group">
              <img
                src={IMAGES.blueprint}
                alt="Engineering blueprint drawing"
                className="w-full h-64 md:h-80 object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#F5F1EA] to-transparent" />
              <span className="absolute bottom-4 left-4 font-mono-tech text-[10px] uppercase tracking-widest text-[#55524B]">
                Precision · By Design
              </span>
            </Reveal>
          </div>

          {/* Right capability grid (blueprint borders) */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 border-l border-t border-[#C9C3B4]">
              {CAPABILITIES.map((cap, i) => (
                <Reveal
                  key={cap.k}
                  delay={(i % 2) * 0.05}
                  className="group border-r border-b border-[#C9C3B4] p-7 md:p-8 hover:bg-[#EBE7DE] transition-colors duration-400"
                >
                  <span className="font-mono-tech text-xs text-[#0055FF]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-display font-700 text-lg md:text-xl mt-4 tracking-tight text-[#0F172A]">
                    {cap.k}
                  </h3>
                  <p className="text-[#55524B] text-sm mt-2 leading-relaxed">
                    {cap.v}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#C9C3B4] border border-[#C9C3B4] mt-16 md:mt-24">
          {STATS.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 0.06}
              className="bg-[#F5F1EA] p-8 md:p-10"
            >
              <div className="font-display font-900 tracking-tighter text-4xl md:text-5xl text-[#0F172A]">
                {s.value}
              </div>
              <div className="font-mono-tech text-[10px] md:text-xs uppercase tracking-widest text-[#55524B] mt-3">
                {s.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
